import { FC, useContext, useMemo } from 'react';
import { Typography, Box } from '@mui/material';

import { MapProvider } from '../../../providers/GoogleMapProvider';
import { MapComponent } from '../../../components/GoogleMap/map';
import { getLocalizedValue } from '../../../utils/helpers/dataHelpers';
import { LanguageContext } from '../../../providers/LanguageProvider';
import { useAppSelector } from '../../../hooks/reduxHooks';

export const MAP_API_KEY = 'AIzaSyAx729ivsmNCOFlPowl9N4AeqldnqgXXWg';

type Props = {
  forContactUs?: boolean;
  data: UIComponentViewDto[];
};

export const MapWrapper: FC<Props> = ({ forContactUs, data }) => {
  const { lang } = useContext(LanguageContext);

  const locale = useAppSelector((st) => st.locale);

  const messages = useMemo(() => {
    return {
      contact_us_appointment_note: locale['contact_us_appointment_note'],
    };
  }, [locale]);

  return (
    <div
      className='map-wrapper'
      style={{
        minHeight: '560px',
        position: 'relative',
      }}
    >
      <MapProvider>
        <MapComponent></MapComponent>
      </MapProvider>
      {forContactUs ? (
        <Box className='contact-block'>
          <Typography
            variant='h3'
            sx={{ fontSize: { md: '36px' }, lineHeight: { md: '44px' }, fontWeight: { md: 450 } }}
          >
            {data && getLocalizedValue(data[0]?.localizations, lang)}
          </Typography>
          <Box style={{ display: 'flex', flexDirection: 'row', gap: '24px' }}>
            <Box className='contact-item'>
              <Typography variant='h4' sx={{ lineHeight: '24px', letterSpacing: '1px', color: '#808080' }}>
                {data && getLocalizedValue(data[1]?.localizations, lang)}
              </Typography>
              <Box style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                <Typography
                  variant='body2'
                  sx={{ fontSize: '16px', color: '#535353', letterSpacing: '-.75px', maxWidth: '270px' }}
                >
                  {data && getLocalizedValue(data[2]?.localizations, lang)}
                </Typography>
                <Typography
                  variant='body2'
                  sx={{
                    fontSize: '16px',
                    lineHeight: '24px',
                    color: '#535353',
                    letterSpacing: '-.75px',
                    maxWidth: '270px',
                  }}
                >
                  <a href={`tel:${data && getLocalizedValue(data[3]?.localizations, lang)}`}>
                    {data && getLocalizedValue(data[3]?.localizations, lang)}
                  </a>
                </Typography>
                <Typography
                  variant='body2'
                  sx={{
                    fontSize: '16px',
                    lineHeight: '24px',
                    color: '#535353',
                    letterSpacing: '-.75px',
                    maxWidth: '270px',
                  }}
                >
                  <a href={`tel:${data && getLocalizedValue(data[4]?.localizations, lang)}`}>
                    {data && getLocalizedValue(data[4]?.localizations, lang)}
                  </a>
                </Typography>
                <Typography
                  variant='body2'
                  sx={{
                    fontSize: '16px',
                    lineHeight: '24px',
                    color: '#535353',
                    letterSpacing: '-.75px',
                    maxWidth: '270px',
                  }}
                >
                  <a href={`mailto:${data && getLocalizedValue(data[5]?.localizations, lang)}`}>
                    {data && getLocalizedValue(data[5]?.localizations, lang)}
                  </a>
                </Typography>
                <Typography
                  variant='body2'
                  sx={{
                    fontSize: '16px',
                    lineHeight: '24px',
                    color: '#535353',
                    letterSpacing: '-.75px',
                    maxWidth: '270px',
                  }}
                >
                  <a href={`mailto:${data && getLocalizedValue(data[6]?.localizations, lang)}`}>
                    {data && getLocalizedValue(data[6]?.localizations, lang)}
                  </a>
                </Typography>
              </Box>
            </Box>
            <Box className='contact-item'>
              <Typography variant='h4' sx={{ lineHeight: '24px', letterSpacing: '1px', color: '#808080' }}>
                {data && getLocalizedValue(data[7]?.localizations, lang)}
              </Typography>
              <Typography variant='body2' sx={{ fontSize: '16px', color: '#535353', letterSpacing: '-.75px' }}>
                {data && getLocalizedValue(data[8]?.localizations, lang)}
              </Typography>
              <Typography variant='body2' sx={{ fontSize: '16px', color: '#535353', letterSpacing: '-.75px' }}>
                {data && getLocalizedValue(data[9]?.localizations, lang)}
              </Typography>
            </Box>
          </Box>
          <Typography variant='body2' sx={{ fontSize: '16px', color: '#535353', letterSpacing: '-.75px' }}>
            {messages.contact_us_appointment_note}
          </Typography>
        </Box>
      ) : null}
    </div>
  );
};
